import React, { useEffect, useState } from "react";

import sortedIcon from "../../assets/images/png/sortedIcon.png";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import { memo } from "react";
// import { useEffect } from "react";
import SortingHook from "../../utils/Hooks/SortingHook";

const VehicleChildRenderer = ({ eachVehicle, columns, rowData }) => {
  return (
    <>
      {eachVehicle.isSecondChild ? (
        <tr className="secondChild">
          {columns.map((eachColumn) => {
            return (
              <td
                style={{
                  padding: "14px 0",
                }}
              >
                {eachColumn?.isSecondChild
                  ? eachColumn?.cellRenderer
                    ? eachColumn?.cellRenderer(
                        eachVehicle,
                        eachColumn.key,
                        rowData
                      )
                    : JSON.stringify(eachVehicle[eachColumn.key])
                  : ""}
              </td>
            );
          })}
        </tr>
      ) : (
        <tr>
          {columns.map((eachColumn) => {
            return (
              <td
                style={{
                  padding: "14px 0",
                }}
              >
                {eachColumn?.cellRenderer
                  ? eachColumn?.cellRenderer(
                      eachVehicle,
                      eachColumn.key,
                      rowData
                    )
                  : JSON.stringify(eachVehicle[eachColumn.key])}
              </td>
            );
          })}
        </tr>
      )}
    </>
  );
};

const VehicleRender = ({
  eachData,
  columns,
  rowData,
  sortingKey,
  isAscending,
}) => {
  const [firstElem, ...restElem] = eachData;

  const { keyToSort, arrData, setKeyForOrdering } = SortingHook(
    restElem,
    sortingKey,
    isAscending
  );

  useEffect(() => {
    setKeyForOrdering(
      sortingKey,
      keyToSort === sortingKey ? !isAscending : false
    );
  }, [sortingKey, isAscending]);

  return (
    <>
      {[firstElem]?.map((eachVehicle) => (
        <VehicleChildRenderer
          eachVehicle={eachVehicle}
          columns={columns}
          rowData={rowData}
        />
      ))}

      {arrData?.map((eachVehicle) => (
        <VehicleChildRenderer
          eachVehicle={eachVehicle}
          columns={columns}
          rowData={rowData}
        />
      ))}
    </>
  );
};

const UnrealisedFolioTable = ({ data, columns, rowData }) => {
  const [isAscending, setIsAscending] = useState(false);
  const [sortingKey, setsortingKey] = useState("currentValue");

  const headerRenderer = ({ label, key, classn, width, sortable }) => {
    return (
      <td className={classn && classn} style={{ width: width }}>
        <div
          className="header_cell"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setsortingKey((prev) => (key === prev ? prev : key));
            setIsAscending((prev) => (key === sortingKey ? !prev : false));
          }}
        >
          <p>{label}</p>
          {sortable && (
            <>
              <div className="accordion_table_header_child_icon">
                <img
                  src={
                    !isAscending && sortingKey === key
                      ? sortedAtoz
                      : isAscending && sortingKey === key
                      ? sortedIcon
                      : sortingKey !== key
                      ? unsortedIcon
                      : ""
                  }
                  alt="sort"
                />
              </div>
            </>
          )}
        </div>
      </td>
    );
  };

  return (
    <>
      <table className="table accordion_content_custom_table ">
        <thead>
          <tr>
            {columns?.map((item) => {
              return headerRenderer(item, rowData);
            })}
          </tr>
        </thead>
        <tbody className="unrealised_report_table">
          {Object.values(data)?.map((eachData) => {
            return (
              <VehicleRender
                eachData={eachData}
                columns={columns}
                rowData={rowData}
                sortingKey={sortingKey}
                isAscending={isAscending}
              />
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default memo(UnrealisedFolioTable);
